<template>
  <div v-if="dialogVisible" class="modal-mask">
    <div class="modal-wrap">
      <header class="modal-header-wrap header">
        <span style="margin-right:40px">选择城市</span>
        <div style="display:inline-block;position:relative">
          <input v-model="searchKeyWord" class="fd-industry-header-search" placeholder="请输入城市关键词" @focus="getSearchOptions" @input="getSearchOptions" />
          <span class="fd-industry-header-search-icon">
            <i class="el-icon-search" style="cursor: initial;"></i>
          </span>
          <div :class="{'fd-industry-dialog-options-wrapper':true, 'fd-industry-hide':hideSearchOptionVisible||!searchKeyWord}">
            <div v-if="searchOptions.length>0" class="fd-industry-dialog-options">
              <ul>
                <li v-for="item in searchOptions" :key="item.value" style="height: 60px; line-height: 60px;" @click="addTag(item.value, item.parent)">
                  <span v-html="item.template"></span>
                </li>
              </ul>
            </div>
            <div v-else-if="searchOptions.length===0" class="fd-industry-dialog-options-wrapper-not-found">
              暂无匹配城市，请在下方选择城市
            </div>
          </div>
        </div>

        <a class="modal-close-btn" href="javascript:;" @click="close">×</a>
      </header>
      <div class="modal-content">
        <div class="data-select">
          <div class="data-select-result-wrap">
            <em>最多选择15项:</em>
            <a v-for="item in chooseCity" :key="item" href="javascript:;" @click="removeTag(item)">{{item}}</a>
          </div>
          <ul class="data-select-tabs-wrap clearfix">
            <li :class="{'active':activeTab==='全部'}" @click="chooseTab('全部')">全部</li>
            <li v-for="item in tabs" :key="item" :class="{'active':activeTab===item}" @click="chooseTab(item)">{{item}}</li>
          </ul>
          <div class="data-select-content-wrap clearfix">
            <template v-if="activeTab==='全部'">
              <dl class="data-group">
                <dt>热门城市</dt>
                <dd class="clearfix">
                  <label v-for="item in hotcity" :key="item" class="data-item">
                    <a href="javascript:;" :class="{'active':chooseCity.includes(item)}" clickable @click="addTag(item)"><span :title="item">{{item}}</span></a>
                  </label>
                </dd>
              </dl>
              <dl class="data-group">
                <dt>全部省份</dt>
                <dd class="clearfix">
                  <label v-for="item in citys" :key="item.label" class="data-item">
                    <a href="javascript:;" :class="{'active':chooseCity.includes(item.label)}" clickable @click="chooseProvince(item)">
                      <span :title="item.label">{{item.label}}</span>
                      <i v-if="getChooseCityNum(item.children)">{{getChooseCityNum(item.children)}}</i>
                    </a>
                  </label>
                </dd>
              </dl>
              <a href="javascript:;" class="data-collect" @click="chooseOverseas">
                海外及港澳台
                <i v-if="getChooseCityNum(overseas)">{{getChooseCityNum(overseas)}}</i>
              </a>
            </template>
            <template v-if="showProvince">
              <p class="data-all-wrap data-item"><a href="javascript:;" :class="{'active':chooseCity.includes(showProvince.label)}" @click="addTag(showProvince.label,showProvince.children)">{{showProvince.label}}</a></p>
              <label v-for="item in showProvince.children" :key="item.label" class="data-item">
                <a href="javascript:;" :class="{'active':chooseCity.includes(item)}" clickable @click="addTag(item,showProvince.label)"><span :title="item">{{item}}</span></a>
              </label>
            </template>
            <template v-if="activeTab === '海外及港澳台'">
              <dl class="data-group">
                <dt>港澳台</dt>
                <dd class="clearfix">
                  <label v-for="item in overseasCity.港澳台" :key="item" class="data-item">
                    <a href="javascript:;" :class="{'active':chooseCity.includes(item)}" clickable @click="addTag(item)"><span :title="item">{{item}}</span></a>
                  </label>
                </dd>
              </dl>
              <dl class="data-group">
                <dt>热门国家</dt>
                <dd class="clearfix">
                  <label v-for="item in overseasCity.热门国家" :key="item" class="data-item">
                    <a href="javascript:;" :class="{'active':chooseCity.includes(item)}" clickable @click="addTag(item)">
                      <span :title="item">{{item}}</span>
                    </a>
                  </label>
                </dd>
              </dl>
              <dl class="data-group">
                <dt>全部大洲</dt>
                <dd class="clearfix">
                  <label v-for="(children,continent) in overseasCity.全部大洲" :key="continent" class="data-item">
                    <a href="javascript:;" :class="{'active':chooseCity.includes(continent)}" clickable @click="chooseContinent(continent,children)">
                      <span :title="continent">{{continent}}</span>
                      <i v-if="getChooseCityNum(children)">{{getChooseCityNum(children)}}</i>
                    </a>
                  </label>
                </dd>
              </dl>
            </template>
            <template v-if="showContinent">
              <p class="data-all-wrap data-item"><a href="javascript:;" :class="{'active':chooseCity.includes(showContinent.label)}" @click="addTag(showContinent.label,showContinent.children)">{{showContinent.label}}</a></p>
              <label v-for="item in showContinent.children" :key="item.label" class="data-item">
                <a href="javascript:;" :class="{'active':chooseCity.includes(item)}" clickable @click="addTag(item,showContinent.label)"><span :title="item">{{item}}</span></a>
              </label>
            </template>
          </div>
        </div>
      </div>
      <footer class="modal-footer"><a @click="confirm">确定</a></footer>
    </div>
  </div>
</template>
<script>
import liepin from '../../../../company/statistics/constant/liepin'

export default {
  props: {
    // default: { type: Array, default: () => [] },
    readonly: { type: Boolean, default: false },
  },
  data: function () {
    return {
      dialogVisible: false,
      tabs: [],
      hotcity: liepin.热门省市,
      citys: liepin.省市,
      showProvince: null,
      activeTab: '全部',
      overseasCity: liepin.城市,
      overseas: [],
      showContinent: null,
      chooseCity: [],
      searchKeyWord: '',
      searchOptions: [],
      hideSearchOptionVisible: false,
    }
  },
  // watch: {
  //   default: {
  //     handler(newValue, oldValue) {
  //       this.chooseCity = window._.cloneDeep(newValue || [])
  //     },
  //     immediate: true,
  //   },
  // },
  mounted() {
    const continent = []
    for (const key in liepin.城市.全部大洲) {
      continent.push(key, ...liepin.城市.全部大洲[key])
    }
    const arr = [...liepin.城市.港澳台, ...liepin.城市.热门国家, ...continent]
    const setObj = new Set(arr)
    this.overseas = [...setObj]
    this.getDefaultSearchOptions()
  },
  methods: {
    open(defaultVal, func) {
      this.dialogVisible = true
      this.chooseCity = window._.cloneDeep(defaultVal || [])
      this.confirmFunc = func
    },
    close() {
      this.dialogVisible = false
    },
    getSearchOptions() {
      const { defaultSearchOptions, searchKeyWord } = this
      this.hideSearchOptionVisible = false
      if (!searchKeyWord) return (this.searchOptions = [])

      const match = defaultSearchOptions
        .filter((val) => val.value.includes(searchKeyWord))
        .map((val) => ({
          value: val.value,
          template: val.value.replace(searchKeyWord, `<span class="fd-industry-high-light">${searchKeyWord}</span>`),
          parent: val.parent,
        }))
      this.searchOptions = match
    },
    hideSearchOptions() {
      setTimeout(() => {
        this.hideSearchOptionVisible = true
      }, 100)
    },
    getDefaultSearchOptions() {
      const options = []
      this.citys.forEach((val) => {
        options.push({ value: val.label, parent: val.label })
        val.children.forEach((v) => {
          options.push({ value: v, parent: val.label })
        })
      })
      this.hotcity.forEach((val) => {
        if (!options.some((o) => o.value === val)) {
          options.push({ value: val, parent: val })
        }
      })
      for (const type in this.overseasCity) {
        const children = this.overseasCity[type]
        if (Array.isArray(children)) {
          children.forEach((v) => {
            options.push({ value: v, parent: type })
          })
        } else {
          for (const secondKey in children) {
            const thirdChildren = children[secondKey]
            thirdChildren.forEach((v) => {
              options.push({ value: v, parent: secondKey })
            })
          }
        }
      }
      this.defaultSearchOptions = options
    },
    confirm() {
      if (this.readonly) this.close()
      this.confirmFunc && this.confirmFunc(this.chooseCity)
      // this.$emit('confirm', this.chooseCity)
      this.dialogVisible = false
    },
    chooseTab(item) {
      this.activeTab = item
      if (item === '全部' || item === '海外及港澳台') {
        this.showProvince = null
        this.showContinent = null
      }
      if (item === '全部') this.tabs = []
      if (item === '海外及港澳台') this.tabs.splice(1)
    },
    chooseProvince(item) {
      this.tabs = [item.label]
      this.activeTab = item.label
      this.showProvince = item
    },
    chooseContinent(continent, children) {
      this.tabs.push(continent)
      this.activeTab = continent
      this.showContinent = { label: continent, children }
    },
    chooseOverseas() {
      this.tabs = ['海外及港澳台']
      this.activeTab = '海外及港澳台'
    },
    getChooseCityNum(item) {
      let num = 0
      for (const v of item) {
        if (this.chooseCity.includes(v)) num += 1
      }
      return num
    },
    addTag(item, removeTag) {
      if (this.readonly) return
      if (this.chooseCity.includes(item)) {
        const index = this.chooseCity.findIndex((v) => v === item)
        if (index !== -1) this.chooseCity.splice(index, 1)
      } else if (this.chooseCity.length !== 15) {
        if (removeTag) {
          if (Array.isArray(removeTag)) {
            for (const tag of removeTag) {
              const index = this.chooseCity.findIndex((v) => v === tag)
              if (index !== -1) this.chooseCity.splice(index, 1)
            }
          } else {
            const index = this.chooseCity.findIndex((v) => v === removeTag)
            if (index !== -1) this.chooseCity.splice(index, 1)
          }
        }
        this.chooseCity.push(item)
      } else if (removeTag && Array.isArray(removeTag)) {
        for (const tag of removeTag) {
          const index = this.chooseCity.findIndex((v) => v === tag)
          if (index !== -1) this.chooseCity.splice(index, 1)
        }
        this.chooseCity.push(item)
      }
      this.searchKeyWord = ''
      this.searchOptions = []
      this.hideSearchOptionVisible = true
    },
    removeTag(item) {
      if (this.readonly) return
      const index = this.chooseCity.findIndex((v) => v === item)
      if (index !== -1) this.chooseCity.splice(index, 1)
    },
  },
}
</script>
<style>
.el-input.is-disabled.disabled-input .el-input__inner {
  background-color: #fff;
  cursor: pointer;
}
.disabled-input i {
  color: #409eff;
}
</style>
<style scoped>
html * {
  box-sizing: border-box;
}
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1008;
  display: block;
}
.modal-mask .modal-wrap {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  background-color: #fff;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.modal-mask .modal-wrap .modal-header-wrap {
  position: relative;
}
.modal-mask .modal-wrap .modal-header-wrap.header {
  padding: 10px 24px 10px 12px;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
}
.modal-mask .modal-wrap .modal-header-wrap .modal-close-btn {
  position: absolute;
  top: 0;
  right: 0;
  padding: 10px;
  text-decoration: none;
  color: #eee;
}
.modal-wrap .modal-close-btn {
  position: absolute;
  top: 0;
  right: 0;
  padding: 10px;
  line-height: 1;
  text-decoration: none;
  color: #eee;
  z-index: 9;
}
.modal-mask .modal-wrap .modal-close-btn {
  font-size: 20px;
  color: #999 !important;
}
.modal-mask .modal-wrap .modal-content {
  padding: 0 34px;
}
.data-select {
  width: 640px;
  font-size: 12px;
}
.data-select-result-wrap em {
  margin-right: 10px;
  color: #678;
  font-style: normal;
}
html a {
  color: #3d9ccc;
  transition: color 0.3s ease;
}
.data-select-content-wrap {
  box-sizing: border-box;
  min-height: 330px;
  background-color: #fcfcfc;
  border: 1px solid #e5e5e5;
  padding: 14px 0 18px 14px;
  border-radius: 2px;
  line-height: 26px;
}

.data-select-result-wrap a {
  display: inline-block;
  background-color: #29c;
  border-radius: 15px;
  padding: 0 14px;
  color: #fff;
  margin: 0 5px 0 0;
  white-space: nowrap;
  cursor: pointer;
  text-decoration: none;
}
.data-select-content-wrap .data-item a {
  display: inline-block;
  line-height: 26px;
  padding: 0 10px;
  white-space: nowrap;
  text-decoration: none;
  color: #0077b3;
  background-color: transparent;
}

.data-select-tabs-wrap {
  padding: 0;
  margin: 0;
  list-style: none;
}
.data-select-result-wrap {
  line-height: 22px;
  padding: 10px 0;
}
.data-select-tabs-wrap li {
  float: left;
  position: relative;
  padding: 0 15px;
  color: #333;
  border: solid #d9d9d9;
  border-width: 1px 1px 0;
  line-height: 26px;
  margin-right: -1px;
  border-radius: 2px;
  cursor: pointer;
}
html .clearfix:after,
html .clearfix:before {
  display: block;
  height: 0;
  content: '';
  clear: both;
}
.data-select-content-wrap dl {
  list-style: none;
  padding: 0;
  margin: 0;
}
.data-select-content-wrap dl dt {
  list-style: none;
  padding: 0 0 0 10px;
  margin: 0 0 10px;
  font-weight: 700;
}
.data-select-content-wrap dl dd {
  margin: 0;
  list-style: none;
}
.data-select-content-wrap .data-item {
  float: left;
  display: inline-block;
  width: 104px;
  vertical-align: middle;
}
.data-select-content-wrap .data-item a > span {
  float: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 70px;
}

.data-select-content-wrap .data-all-wrap.data-item {
  display: block;
  float: none;
  text-overflow: ellipsis;
  margin: 0;
  width: auto;
  vertical-align: middle;
  overflow-x: hidden;
}
.data-select-content-wrap .data-item a > i,
.data-select-content-wrap .data-collect > i {
  font-style: normal;
  color: #fff;
  background-color: #0077b3;
  padding: 0 3px;
  margin-left: 3px;
  border-radius: 5px;
}

.data-select-content-wrap .data-collect {
  display: block;
  margin: 10px 25px 0 0;
  border: 1px dashed #a2b6c6;
  line-height: 30px;
  text-decoration: none;
  text-align: center;
  color: #678;
}
.modal-mask .modal-wrap .modal-footer {
  border-top: 0;
}

.modal-mask .modal-wrap .modal-footer {
  padding: 10px 12px;
  text-align: center;
  border-top: 1px solid #eee;
  font-size: 12px;
}
.modal-mask .modal-wrap .modal-footer a {
  border-radius: 3px;
  background: #3d9ccc;
  line-height: 28px;
  height: 28px;
  color: #fff;
  padding: 0 14px;
  text-decoration: none;
}
.modal-mask .modal-wrap .modal-footer a {
  display: inline-block;
  border: 1px solid #eee;
}
.data-select-tabs-wrap .active {
  padding-bottom: 1px;
  margin-bottom: -1px;
  background-color: #fcfcfc;
}
.data-select-content-wrap .data-item a:hover {
  color: #f93;
  background-color: #d5e9f2;
}

.data-select-content-wrap .data-item a.active {
  color: #fff;
  background-color: #3d9ccc;
}
.fd-industry-header-search {
  background-color: #f5f5f5;
  border: 1px solid #f5f5f5;
  outline: none;
  border-radius: 12px;
  font-size: 12px;
  line-height: 17px;
  padding: 0 12px;
  margin-top: 2px;
  width: 260px;
  height: 24px;
  vertical-align: top;
  display: inline-block;
}
.fd-industry-header-search-icon {
  color: #ccc;
  position: absolute;
  height: 24px;
  line-height: 24px;
  top: 50%;
  margin-top: -12px;
  right: 12px;
}
.fd-industry-dialog-options-wrapper {
  position: absolute;
  top: 30px;
  left: 0;
  width: 260px;
  z-index: 2;
}
.fd-industry-hide {
  display: none !important;
}
.fd-industry-dialog-options {
  background-color: #fff;
  border: 1px solid #f8f8f8;
  width: 260px;
  max-height: 260px;
  overflow: auto;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.15);
}
.fd-industry-dialog-options ul {
  padding: 0;
  margin: 0;
  list-style: none;
}
.fd-industry-dialog-options ul li {
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  list-style: none;
  line-height: 40px;
  padding: 0 16px;
  transition: all 0.3s;
}

.fd-industry-dialog-options ul li:hover {
  background-color: #f8f8f8;
}
.fd-industry-dialog-options-wrapper-not-found {
  font-weight: 400;
  background-color: #fff;
  color: #999;
  font-size: 12px;
  line-height: 17px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  padding: 10px 12px;
}
.data-select-result-wrap a:nth-child(10) ~ a{
  margin-top: 6px;
}
</style>


